import { render } from "./CompareTool.vue?vue&type=template&id=95f32bd0"
import script from "./CompareTool.vue?vue&type=script&lang=js"
export * from "./CompareTool.vue?vue&type=script&lang=js"

import "./CompareTool.vue?vue&type=style&index=0&id=95f32bd0&lang=scss"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__